<template>
   <nav class="navbar navbar-expand-md navbar-light fixed-top py-3" id="mainNav">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <img class="logo" src="/img/logos/coralstone-logo.svg" alt="">
        </router-link>
        <span class="navbar-toggler">
          <img class="menu" src="/img/mobile/menu.svg" alt="logo">
        </span>
        <div class="navbar-wrapper">
          <ul class="navbar-nav ml-auto my-2 my-lg-0">
            <li class="logo-wrap">
              <router-link class="nav-logo" to="/">
                <img src="/img/logos/Normal-Logo.png" alt="">
              </router-link>
              <a class="exit-menu" href="#">
                <img src="/img/mobile/close.svg" alt="">
              </a>
            </li>
            <li class="nav-item">
              <router-link to= "/about" class="nav-link">About Us</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="http://blog.coralstone.capital">Blog</a>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/careers">Careers</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/contact">Contact Us</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
</template>

<script>

export default {
  mounted() {
    const top = document.querySelector('#mainNav');
    const logo = document.querySelector('.logo');
    const menu = document.querySelector('.menu');
    const navbarWrapper = document.querySelector('.navbar-wrapper');
    const exitMenu = document.querySelector('.exit-menu');

    window.addEventListener('scroll', () => {
      //console.log(window.scrollY)
      if(window.scrollY > 50) {
        top.classList.add('navbar-scrolled')
        logo.src = '/img/logos/Normal-Logo.png';
        menu.src = '/img/mobile/menu-black.svg';
      } else {
        top.classList.remove('navbar-scrolled')
        logo.src = '/img/logos/coralstone-logo.svg';
        menu.src = '/img/mobile/menu.svg';

      }
    });

    menu.addEventListener('click', function() {
      //console.log('clicked menu icon')
      navbarWrapper.classList.add('show');
    })

    exitMenu.addEventListener('click', function() {
      //console.log('exit menu icon clicked')
      navbarWrapper.classList.remove('show');
    })
  }
}
</script>

<style lang="scss" scoped>
  //#mainNav {
    //background: transparent;
    //box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  
  //}

  


</style>